import imageOne from '@/assets/images/cities/thunderbay1.jpg'
import imageTwo from '@/assets/images/cities/thunderbay2.jpg'
import imageThree from '@/assets/images/cities/thunderbay3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Thunder Bay',
  writeup: '',
  website: 'ThunderBayNotary.com',
  url: 'https://www.thunderbaynotary.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(807) 333-0110',
      hours: {
        monday: '10:00AM to 5:00PM',
        tuesday: '10:00AM to 5:00PM',
        wednesday: '10:00AM to 5:00PM',
        thursday: '10:00AM to 5:00PM',
        friday: '10:00AM to 5:00PM',
        saturday: '',
        sunday: ''
      },
      address: '620 Victoria Avenue Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontario/cities/thunderBay.js